export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-movie-2-line text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">91樱花</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              91樱花是国内领先的动漫在线观看与下载平台，提供海量日漫、国漫、剧场版等优质动漫资源。每日同步更新，高清画质无删减，全集免费追番，为动漫爱好者打造最好的追番家园。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm text-background-300 hover:text-background-50"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm text-background-300 hover:text-background-50"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm text-background-300 hover:text-background-50"></i>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">热门榜单</a>
              <a href="#carousel" onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">专题推荐</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400 whitespace-nowrap">热门日漫</span>
              <span className="text-sm text-background-400 whitespace-nowrap">精品国漫</span>
              <span className="text-sm text-background-400 whitespace-nowrap">剧场版</span>
              <span className="text-sm text-background-400 whitespace-nowrap">新番速递</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              期待与更多优秀的动漫内容方、平台方建立合作关系，共同为动漫爱好者提供更丰富的内容体验。
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91樱花. 本站所有内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}